// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgHouse: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path
          fillRule="evenodd"
          d="M2.25 10.005H3v10.5a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-10.5h.75c.72 0 1.027-.918.45-1.35L12.9 1.68a1.5 1.5 0 0 0-1.8 0L1.8 8.655c-.577.432-.27 1.35.45 1.35M12 3.499 5.985 8.01h12.03zM4.995 20.01V10.005H19V20.01h-3.002v-5.69c0-.716-.581-1.297-1.298-1.297H9.3c-.717 0-1.297.58-1.297 1.297v5.69zm9.008 0H10l-.002-4.992h4.005z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgHouse);
export default Memo;
